import {
  LayoutDashboard,
  Radar,
  Shield,
  Bot,
  Gauge,
  BrickWall,
  Bug,
  Globe,
  Lock,
  Layers,
  Settings,
  FileCode,
  ListFilter,
  ShieldAlert,
  KeyRound,
  FileCheck,
  Fingerprint,
  ScrollText,
  BarChart3,
  Activity,
  Radio,
  Plug,
  Scale,
  GitPullRequest,
  Network,
  Sparkles,
  DatabaseZap,
  Zap,
  ScanLine,
  Bell,
  Webhook,
  Building2,
  Users,
  User,
  ShieldCheck,
  FolderKanban,
  Search,
  FileWarning,
  Lightbulb,
  CircleHelp,
  BookOpen,
  ClipboardList,
  Plus,
  ChevronDown,
  ChevronUp,
  LogOut,
  X,
  Check,
  Eye,
} from "lucide-react";

/** Longest-prefix wins — keep more specific paths first. */
const ROUTE_ICON_ENTRIES = [
  { prefix: "/v2/detection/web_application/dashboard", icon: LayoutDashboard },
  { prefix: "/v2/services/web_application/dashboard", icon: LayoutDashboard },
  { prefix: "/v2/detection/bot/dashboard", icon: LayoutDashboard },
  { prefix: "/v2/detection/waf_event", icon: Shield },
  { prefix: "/v2/detection/bot_event", icon: Bot },
  { prefix: "/v2/detection/rate_limit_event", icon: Gauge },
  { prefix: "/v2/detection/firewall_event", icon: BrickWall },
  { prefix: "/v2/services/waf_configuration", icon: LayoutDashboard },
  { prefix: "/v2/services/web_application/config", icon: Settings },
  { prefix: "/v2/services/web_application/custom_rules", icon: FileCode },
  { prefix: "/v2/services/rate_limit_rules", icon: Gauge },
  { prefix: "/v2/services/firewall_rules", icon: BrickWall },
  { prefix: "/v2/services/bot/config", icon: Settings },
  { prefix: "/v2/services/bot/exception", icon: ListFilter },
  { prefix: "/v2/services/ddos/exceptions", icon: ListFilter },
  { prefix: "/v2/services/ddos_config", icon: ShieldAlert },
  { prefix: "/v2/csp/config", icon: FileCode },
  { prefix: "/v2/csp/inventory", icon: FolderKanban },
  { prefix: "/v2/api-security/schema", icon: FileCheck },
  { prefix: "/v2/api-security/specs", icon: FileCheck },
  { prefix: "/v2/api-security/discovery", icon: Radar },
  { prefix: "/v2/api-security/authorization", icon: ShieldAlert },
  { prefix: "/v2/api-security/risk-score", icon: Scale },
  { prefix: "/v2/api-security/threat-intel", icon: Radio },
  { prefix: "/v2/api-security/proposals", icon: GitPullRequest },
  { prefix: "/v2/api-security/dependencies", icon: Network },
  { prefix: "/v2/api-security/ai-callers", icon: Sparkles },
  { prefix: "/v2/api-security/events_capture", icon: DatabaseZap },
  { prefix: "/v2/api-security/catalog", icon: Radar },
  { prefix: "/v2/api-security/auth", icon: KeyRound },
  { prefix: "/v2/api-security/dlp", icon: ScrollText },
  { prefix: "/v2/api-security/graphql", icon: FileCode },
  { prefix: "/v2/api-security/events", icon: Zap },
  { prefix: "/v2/api-security/posture", icon: BarChart3 },
  { prefix: "/v2/api-security/anomaly", icon: ScanLine },
  { prefix: "/v2/api-security/siem", icon: Plug },
  { prefix: "/v2/api-security", icon: ShieldCheck },
  { prefix: "/v2/settings/audit-logs", icon: ScrollText },
  { prefix: "/v2/settings/webhooks", icon: Webhook },
  { prefix: "/v2/settings/alerts", icon: Bell },
  { prefix: "/v2/settings/sso", icon: Fingerprint },
  { prefix: "/v2/settings/organisation", icon: Building2 },
  { prefix: "/v2/settings/users", icon: Users },
  { prefix: "/v2/settings/project", icon: FolderKanban },
  { prefix: "/v2/settings/account", icon: User },
  { prefix: "/v2/settings", icon: Settings },
  { prefix: "/v2/findings/threat-insights", icon: Lightbulb },
  { prefix: "/v2/findings/posture", icon: ShieldCheck },
  { prefix: "/v2/findings", icon: FileWarning },
  { prefix: "/v2/sites/new", icon: Plus },
  { prefix: "/v2/sites", icon: Globe },
  { prefix: "/v2/ssl-tls", icon: Lock },
  { prefix: "/v2/certs", icon: Lock },
  { prefix: "/v2/detection", icon: Radar },
  { prefix: "/v2/services", icon: Layers },
  { prefix: "/v2/overview", icon: LayoutDashboard },
];

export function getPageIconForPath(pathname) {
  const path = (pathname || "").split("?")[0];
  const entry = ROUTE_ICON_ENTRIES.find(
    (r) => path === r.prefix || path.startsWith(`${r.prefix}/`)
  );
  return entry?.icon ?? LayoutDashboard;
}

/** Top-level sidebar rail icons (order matches Normal.js filteredItems). */
export const V2_MAIN_NAV_ICONS = {
  Overview: LayoutDashboard,
  Detection: Radar,
  Findings: FileWarning,
  Sites: Globe,
  "SSL/TLS": Lock,
  Services: Layers,
  "API Security": ShieldCheck,
  Settings: Settings,
};

/** Navbar / chrome Lucide icons */
export const V2_CHROME_ICONS = {
  search: Search,
  help: CircleHelp,
  notification: Bell,
  documentation: BookOpen,
  releaseNote: ClipboardList,
  plus: Plus,
  chevronDown: ChevronDown,
  chevronUp: ChevronUp,
  organisation: Building2,
  project: FolderKanban,
  account: User,
  logout: LogOut,
  close: X,
  closeSmall: X,
  markRead: Check,
  view: Eye,
};

export {
  LayoutDashboard,
  Radar,
  Shield,
  Bot,
  Gauge,
  BrickWall,
  Bug,
  Globe,
  Lock,
  Layers,
  Settings,
  FileCode,
  ListFilter,
  ShieldAlert,
  KeyRound,
  FileCheck,
  Fingerprint,
  ScrollText,
  BarChart3,
  Activity,
  Radio,
  Plug,
  Scale,
  GitPullRequest,
  Network,
  Sparkles,
  DatabaseZap,
  Zap,
  ScanLine,
  Bell,
  Webhook,
  Building2,
  Users,
  User,
  ShieldCheck,
  FolderKanban,
  Search,
  FileWarning,
  Lightbulb,
};
